import { Brand, createBranded } from '@deltasierra/type-utilities';

export type LocalPrintPublishId = Brand<number, 'LocalPrintPublishId'>;
export const LocalPrintPublishId = createBranded<LocalPrintPublishId>();
